import { caseTiming } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to add a teleradiology customer
export const updateCaseTiming = createAsyncThunk(
  'updateCaseTiming',
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(caseTiming, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch case timing');
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default updateCaseTiming;
